import Vue from 'vue'
//import BootstrapVue from 'bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'

import cdnStuffPlugin from "@/plugins/cdnStuff";
//Vue.use(BootstrapVue)
Vue.use(require('vue-moment'));
Vue.use(cdnStuffPlugin);

Vue.config.productionTip = false
Vue.prototype.$log = console.log
Vue.prototype.window=window;
Vue.prototype.location=location;

var vm= new Vue({
  router,
  store,
  render: (h) => h(App),
});

global.vm = vm;

/*vm.$router.push({name:'match', params:{ id:'9387' }});
vm.$mount('#app');*/
